<template>
  <div @click.stop>
    <label
      v-for="item in values"
      :key="item.label"
      class="flex items-center cursor-pointer select-none leading-none mt-10 text-14"
      @click="onChange(item.value)"
    >
      <span
        class="relative h-17 w-17 border-2 rounded-2 border-grey-700 mr-10"
        :class="{ 'checked': isChecked(item) }"
      />
      {{ item.label }}
    </label>

    <RecurringModal ref="recurringModal" event-type="Edit" @submit="confirm" />
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue'
import RecurringModal from '@/components/confirm/RecurringModal'

export default defineComponent({
  name: 'CheckboxInputGroup',

  components: { RecurringModal },

  props: {
    values: Array,
    modelValue: Object,
    updateImmediately: Boolean
  },

  emits: ['update:modelValue', 'updateRecurring'],

  setup (props, { emit }) {
    const recurringModal = ref(null)
    let eventValue = {}

    const isChecked = computed(() => item => {
      return props.modelValue.type === item.value.type && +props.modelValue.value === +item.value.value
    })

    const confirm = (value) => {
      emit('updateRecurring', { period: eventValue, value })
    }

    function openModal () {
      if (props.updateImmediately) {
        emit('updateRecurring', { period: eventValue })
      } else {
        recurringModal.value.open()
      }
    }

    const onChange = (value) => {
      if (props.modelValue.type === value.type && +props.modelValue.value === +value.value) {
        eventValue = { type: 'none', value: 0 }
        openModal()
      } else if (props.modelValue.type && props.modelValue.value > 0) {
        eventValue = value
        openModal()
      } else {
        emit('update:modelValue', value)
      }
    }

    return {
      recurringModal,
      isChecked,
      onChange,
      confirm
    }
  }
})
</script>

<style lang="scss" scoped>
span.checked.border-grey-700 {
  @apply bg-grey-700;
}

span.checked.border-grey-100 {
  @apply bg-sidebar;
}

span.checked:after {
  @apply block;
}

span:after {
  @apply w-6 h-12 border-grey-main origin-center transform rotate-45 border-r-2 border-b-2 absolute hidden left-4;
  top: -1px;
  content: "";
}
</style>
